import { Instance } from "mobx-state-tree"
import { ChatMessageModelBase } from "./ChatMessageModel.base"

/* The TypeScript type of an instance of ChatMessageModel */
export interface ChatMessageModelType extends Instance<typeof ChatMessageModel.Type> {}

/* A graphql query fragment builders for ChatMessageModel */
export { selectFromChatMessage, chatMessageModelPrimitives, ChatMessageModelSelector } from "./ChatMessageModel.base"

/**
 * ChatMessageModel
 */
export const ChatMessageModel = ChatMessageModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
